import React, { useEffect, useImperativeHandle, useState } from "react"

import BlurWrapper from "@fuse/sharedComponents/blurWrapper"
import { countryData, CountryType } from "@letshang/assets"
import CountriesFlag from "@letshang/assets/countries_flags.json"
import { getPhoneNumberPlaceholder } from "@letshang/utils"
import axios from "axios"

import {
  getDefaultCountry,
  getFormattedPhone,
} from "@fuse/utils/phoneNumberFormater"

const PhoneNumberField = React.forwardRef(
  (
    {
      children,
      readOnly = false,
      setVal,
      country,
      setCountry,
      phoneNumberToBePrefilled,
      parentClassName = "",
    }: {
      children?: React.ReactNode
      readOnly?: boolean
      country: CountryType
      setCountry: React.Dispatch<React.SetStateAction<CountryType>>
      setVal: React.Dispatch<React.SetStateAction<string>>
      phoneNumberToBePrefilled?: string
      parentClassName?: string
    },
    ref,
  ) => {
    const [isSelectOpen, setIsSelectOpen] = React.useState(false)
    const [phoneFormatted, setPhoneFormatted] = useState<string>("")

    useImperativeHandle(ref, () => ({
      checkPhoneLength: (phoneNumber) => {
        const raw = phoneNumberPlaceHolder.placeHolder.replace(/\D/g, "")
        if (phoneNumber.length && phoneNumber.length === raw.length) {
          return true
        } else {
          return false
        }
      },
    }))

    const [phoneNumberPlaceHolder, setPhoneNumberPlaceHolder] = useState({
      placeHolder: "",
      fullNumber: 0,
    })

    useEffect(() => {
      if (phoneNumberToBePrefilled) {
        formatThePhoneNumber(phoneNumberToBePrefilled)
      }
    }, [phoneNumberToBePrefilled])

    const getCurrentCountry = async () => {
      try {
        // write a util function, but added here for a quick fix, when called from util function it was not working giving cors error
        const country = await axios.get("https://ipapi.co/json/")

        if (country.data) {
          console.log("country data - getCurrentCountry", country.data)
          const data = country.data
          const foundCountry = countryData.find(
            (item) => item.code === data.country_code,
          )
          setCountry(foundCountry || getDefaultCountry())
        }
      } catch (err) {
        console.error(err)
      }
    }

    const formatThePhoneNumber = (val: string) => {
      const raw = val.replace(/\D/g, "")
      const formatted = getFormattedPhone(val, country)
      setPhoneFormatted(formatted)
      setVal(() => raw)
    }

    const handlePhoneChange = (
      e: React.ChangeEvent<HTMLInputElement>,
    ): void => {
      const digits = e.target.value
      formatThePhoneNumber(digits)
    }

    const recaptchaRef = React.useRef(null)

    useEffect(() => {
      getCurrentCountry()
    }, [])

    useEffect(() => {
      setPhoneNumberPlaceHolder(getPhoneNumberPlaceholder(country?.code) as any)
      // setPhoneFormatted("")
    }, [country?.code])

    return (
      <div className={parentClassName} ref={recaptchaRef}>
        <div className="text-start text-sm font-medium text-white/35 pb-2">
          Phone number
        </div>
        <div className="flex gap-2 flex-wrap">
          <BlurWrapper
            onClick={() => {
              setIsSelectOpen(!isSelectOpen)
            }}
            className="w-[52px] h-[52px] flex px-2 rounded-lg  items-center justify-center relative"
            overlayColorDefault="light"
            overlayOpacityDefault="20"
          >
            <img
              src={
                CountriesFlag[
                  country?.code?.toLocaleLowerCase() as keyof typeof CountriesFlag
                ]
              }
              alt="india"
              className="w-5 h-5 "
            />
            {isSelectOpen && (
              <div className="absolute top-[60px] left-0 w-full bg-white/20 border-[1px] border-white/10 shadow-md p-[5px] rounded-[5px] cursor-pointer  max-h-[200px] overflow-y-scroll z-50">
                {countryData.map((item, index) => (
                  <div
                    key={index}
                    className={
                      "flex justify-center items-center my-[5px] border-b-[1px] border-white/10 gap-[5px] text-white" +
                      (item.code === country.code ? " bg-[#0000001A]" : " ")
                    }
                    onClick={() => {
                      setCountry(item)
                      setIsSelectOpen(false)
                    }}
                  >
                    <img
                      src={
                        CountriesFlag[
                          item.code?.toLocaleLowerCase() as keyof typeof CountriesFlag
                        ]
                      }
                      alt="india"
                      className="w-[20px] h-[20px]"
                    />
                  </div>
                ))}
              </div>
            )}
          </BlurWrapper>

          <BlurWrapper
            className="flex flex-1 rounded-lg overflow-hidden gap-2 px-2"
            overlayColorDefault="light"
            overlayOpacityDefault="20"
          >
            <div className="flex justify-center items-center text-white text-base font-normal px-1">
              <p>{country.dial_code}</p>
            </div>
            <div className="w-full">
              <input
                type="text"
                inputMode="numeric"
                placeholder={phoneNumberPlaceHolder?.placeHolder}
                className={
                  "text-base bg-transparent flex items-center h-full w-full tracking-[0.5px] placeholder:text-[#6d6d6da9] placeholder:font-[400]  border-0 focus:outline-none  rounded-[0] leading-tight placeholder:tracking-[1px] text-[#fff] font-normal "
                }
                readOnly={readOnly}
                autoFocus
                maxLength={phoneNumberPlaceHolder?.placeHolder.length}
                value={phoneFormatted}
                onChange={handlePhoneChange}
              />
            </div>

            <div className="place-content-center">{children}</div>
          </BlurWrapper>
        </div>
      </div>
    )
  },
)

export default PhoneNumberField
